import { createContext } from 'react'

export type ThemePreference = 'auto' | 'light' | 'dark'
export type ResolvedTheme = 'light' | 'dark'
export type Density = 'compact' | 'default' | 'comfy'

export interface AppearanceContextValue {
  theme: ThemePreference
  resolvedTheme: ResolvedTheme
  setTheme: (next: ThemePreference) => void
  density: Density
  setDensity: (next: Density) => void
}

export const AppearanceContext = createContext<AppearanceContextValue | null>(null)
